import React from 'react'
import { cn } from '@amusnet/react-ui'
import { useUltraPlayStore } from '@stores'
import logoSvg from '@assets/ultra-play/ultra-play-logo.svg'
import animatedLogoSvg from '@assets/ultra-play/ultra-play-logo-animated.svg'
import dividerSvg from '@assets/ultra-play/ultra-play-logo-divider.svg'
import closeButtonSvg from '@assets/close-button.svg'

const UltraPlayModalHeader: React.FC<{
    gameName?: string
    isLandscape?: boolean
    onClose: () => void
}> = ({ gameName, isLandscape, onClose }) => {
    // While playing, swap the static wordmark for the animated one (same dimensions/aspect).
    const isPlaying = useUltraPlayStore((s) => s.status) === 'PLAYING'

    return (
        <div className="relative flex-shrink-0">
            <div className={cn('absolute', isLandscape ? 'top-[14px] right-[21px]' : 'top-[18px] right-6')}>
                <button id="close-ultra-play-button" onClick={onClose} aria-label="Close Ultra Play">
                    <img
                        src={closeButtonSvg}
                        className={cn('', isLandscape ? 'w-[51px] h-[51px]' : 'w-[58px] h-[58px]')}
                        alt="Close"
                    />
                </button>
            </div>
            <div className={cn('flex justify-center', isLandscape ? 'py-[25px]' : 'py-[27px]')}>
                <img
                    src={isPlaying ? animatedLogoSvg : logoSvg}
                    className={cn('', isLandscape ? 'w-[257px] h-[30px]' : 'w-[340px] h-[40px]')}
                    alt="Ultra Play"
                />
            </div>
            <img src={dividerSvg} className="w-full h-0.5" alt="" />
            {gameName && (
                <p
                    className={cn(
                        'text-center text-white font-black',
                        isLandscape ? 'text-[26px] py-[13px]' : 'text-[40px] py-[21px] mb-6'
                    )}
                >
                    {gameName}
                </p>
            )}
        </div>
    )
}

export default UltraPlayModalHeader
